import { gql } from '@apollo/client';

export const sendUserExportEmailQuery = gql`
  query SendUserExportEmail {
    sendUserExportEmail
  }
`;
